/** Constants for the namespace feature. */

// ─── String groups table ────────────────────────────────────────────────────

/** Number of string groups to display per page (client-side pagination). */
export const STRING_GROUPS_PAGE_SIZE = 25;

/** Number of string groups to fetch per backend call. */
export const STRING_GROUPS_FETCH_BATCH_SIZE = 100;

/** Number of initial batches to fetch on mount (5 × 100 = 500 items). */
export const STRING_GROUPS_INITIAL_BATCHES = 5;

/**
 * Minimum characters before the table's text filter is applied. A 1-2 character
 * substring matches almost every row, so the filter is withheld until the input
 * is selective enough to narrow the result set meaningfully.
 */
export const STRING_GROUPS_SEARCH_MIN_CHARS = 3;

// ─── Create String Group form ───────────────────────────────────────────────

/** Minimum character length for the string group name field. */
export const SG_NAME_MIN_LENGTH = 3;

/**
 * Maximum character length for the string group name field. Capped at 50 by
 * product requirement — deliberately stricter than the backend
 * `StringGroupIdentifier` Smithy maximum so a namespace name, string group
 * name, and string ID all share the same 50-character ceiling.
 */
export const SG_NAME_MAX_LENGTH = 50;

/**
 * Characters accepted in a string group name. Mirrors the `StringGroupIdentifier`
 * Smithy constraint in LangHubServiceModel (model/common/scalars.smithy):
 *
 *   @pattern("^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_-]+$")
 *
 * The name becomes the string group's identifier, so a value with spaces (or any
 * other character outside this set) would be rejected server-side. The lookahead
 * additionally requires at least one alphanumeric character, so a name of only
 * hyphens/underscores is invalid.
 */
export const SG_NAME_PATTERN = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_-]+$/;

/** Maximum character length for the string group description field. */
export const SG_DESCRIPTION_MAX_LENGTH = 500;

/**
 * Maximum character length for the string group team name field. Mirrors the
 * `@length(max: 256)` constraint on `StringGroupCreateMetadata.teamName` in
 * LangHubServiceModel — both members of that structure are `@required` with
 * `@length(min: 1)`, so a blank or over-long value is a 400 on submit. The
 * description maximum above is deliberately stricter than its own server-side
 * 1000 and needs no such alignment.
 */
export const SG_TEAM_NAME_MAX_LENGTH = 256;
